@if (loadForm) {
	<main class="form-fields-sub-module pb-[10px]">
		<div class="w-full flex justify-center items-center relative mt-[8px] mb-[48px]">
			<div class="h-[24px] ml-[72px] grow flex mt-[12px] mr-[7px]">
				<div class="h-[2px] grow mt-[12px] mr-[12px]"></div>
				<div class="flex flex-row items-center">
					<button class="btn-secondary btn-type-3" (click)="openChildFormState(true)">
						<lbca-icon name="lucide:chevron-down" class="text-primary" />
					</button>
					<button class="btn-secondary btn-type-3 ml-[4px]" (click)="openChildFormState(false)">
						<lbca-icon name="lucide:chevron-down" class="text-primary rotate-180" />
					</button>
				</div>
			</div>
		</div>
		<lbca-dynamic-form
			[initialized]="true"
			[type]="'form-secondary'"
			[externalData]="dataForm"
			[cardData]="cardInfo"
			[modulesConfig]="formTemplate['subforms']"
			[forceStateOpened]="formState"
			[initialized]="initialized"
			[disabled]="!initialized"
			(subformData)="setChildrenFormData($event)"
			(saveData)="saveData($event)"
		></lbca-dynamic-form>
	</main>
}
